export enum MenuManagementCategoryActionTypes {
    CATEGORY_UPDATE_DISABLE = '@@menuManagement/CATEGORY_UPDATE_DISABLE',
    CATEGORY_UPDATE_DISABLE_SUCCESS = '@@menuManagement/CATEGORY_UPDATE_DISABLE_SUCCESS',
    CATEGORY_UPDATE_DISABLE_ERROR = '@@menuManagement/CATEGORY_UPDATE_DISABLE_ERROR',

    REGISTER_CATEGORY = '@@menuManagement/REGISTER_CATEGORY',
    REGISTER_CATEGORY_SUCCESS = '@@menuManagement/REGISTER_CATEGORY_SUCCESS',
    REGISTER_CATEGORY_ERROR = '@@menuManagement/REGISTER_CATEGORY_ERROR',

    DELETE_CATEGORY = '@@menuManagement/DELETE_CATEGORY',
    DELETE_CATEGORY_SUCCESS = '@@menuManagement/DELETE_CATEGORY_SUCCESS',
    DELETE_CATEGORY_ERROR = '@@menuManagement/DELETE_CATEGORY_ERROR',

    UPDATE_CATEGORY = '@@menuManagement/UPDATE_CATEGORY',
    UPDATE_CATEGORY_SUCCESS = '@@menuManagement/UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_ERROR = '@@menuManagement/UPDATE_CATEGORY_ERROR',

    CATEGORY_UPDATE_ISACTIVE = '@@menuManagement/CATEGORY_UPDATE_ISACTIVE',
    CATEGORY_UPDATE_ISACTIVE_SUCCESS = '@@menuManagement/CATEGORY_UPDATE_ISACTIVE_SUCCESS',
    CATEGORY_UPDATE_ISACTIVE_ERROR = '@@menuManagement/CATEGORY_UPDATE_ISACTIVE_ERROR',

    CATEGORY_OUTLET_LISTS = '@@menuManagement/CATEGORY_OUTLET_LISTS',
    CATEGORY_OUTLET_LISTS_SUCCESS = '@@menuManagement/CATEGORY_OUTLET_LISTS_SUCCESS',
    CATEGORY_OUTLET_LISTS_ERROR = '@@menuManagement/CATEGORY_OUTLET_LISTS_ERROR',

    CATEGORY_ITEM_LIST = '@@menuManagement/CATEGORY_ITEM_LIST',
    CATEGORY_ITEM_LIST_SUCCESS = '@@menuManagement/CATEGORY_ITEM_LIST_SUCCESS',
    CATEGORY_ITEM_LIST_ERROR = '@@menuManagement/CATEGORY_ITEM_LIST_ERROR',
}
